export const VISITOR_ID_REQUEST_WAIT_TIME = 2000;
